import { CheggTlds } from './constants';
/** CheggTld type predicate */
function isCheggTld(tld) {
  return Object.values(CheggTlds).some(function (val) {
    return tld === val;
  });
}
export default isCheggTld;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/utils/dist/esm/urls/isCheggTld.js
// module id = 1182
// module chunks = 11